import React, { useEffect, useRef } from "react";

const Footer = ({ data }) => {
  const scriptLoaded = useRef(false);

  useEffect(() => {
    if (!scriptLoaded.current) {
      const script = document.createElement("script");
      script.src = "https://visitorshitcounter.com/js/badgess.js?v=1738760880";
      script.async = true;
      document.body.appendChild(script);
      scriptLoaded.current = true;
    }
    return () => {
      const script = document.querySelector('script[src="https://visitorshitcounter.com/js/badgess.js?v=1738760880"]');
      if (script) {
        document.body.removeChild(script);
      }
    };
  }, []);


  return (
    <>
      <div className="footer">
        <div className="footer-row">
          <div className="footer-left-upper">
            <div className="footer-left">
              <div className="footer-col footer-col-1">
                <h3 style={{ textTransform: "capitalize" }}>Root And Tooth Dental Clinic</h3>
                 <span style={{fontSize:"15px",fontFamily:"sans-serif",fontWeight:"bold"}}>Reg no: A-10812</span>
                <p style={{ textTransform: "capitalize" }}>
                  Dr. Rahul Raj Ghanghoriya
               Shop no 1 and 2, first floor shree ram palace, next to khedapati mandir balaji nagar. Landmark in front of kanta shravan hotel, Bhopal (462021).
                </p>
                <div className="contact-detail">
                  <p>
                    Contact Number :{" "}
                    <a href="tel:  7771949867"> "+91-7771949867"</a>
                  </p>
                  <p>
                    {/* Contact Number : <a href="tel:  8770195044">+91 8770195044</a> */}
                  </p>
                  <p>
                    Email :{" "}
                    <a href="mailto: rootntoothdentalclinic@gmail com">
                      {" "}
                       rootntoothdentalclinic@gmail com
                    </a>
                  </p>
                </div>
              </div>
              <div className="footer-col footer-col-1">
                <h3>ADDRESS</h3>
                <div className="clinic-time">
                  <p style={{ textTransform: "capitalize" }}>
                    Root AND Tooth Dental clinic
                    <br />Shop no 1 and 2, first floor shree ram palace, next to khedapati mandir balaji nagar. Landmark in front of kanta shravan hotel, Bhopal (462021)
                  </p>
                  {/* <p>
                    <span style={{ color: "#ffff", textTransform: "uppercase" }}>Clinic Time:</span> {data?.data ? data?.data[0]?.clinic_time : "11:00AM - 7:00PM"}
                  </p> */}
                  <p>
                    {/* <span style={{ color: "#ffff" }}>Friday:</span> Closed */}
                  </p>
                </div>

                {/* <div className="clinic-time-r">
              <p>
                <span style={{ color: "#312e7b" }}>Residential address.</span>
                Vipat pura vardhman colony Narsingh pur behind Anjani. Hospital
              </p>
              <p>
                <span style={{ color: "#312e7b" }}>Clinic Time:</span> 8:30AMto
                9:30 AM and 2:00PM to 4:00PM Monday-saturday
              </p>
            </div> */}
              </div>
            </div>
            {/* <div className="footer-right">
              <div className="footer-left-down">
                <a
                  class="hitCounter"
                  href="https://visitorshitcounter.com/"
                  target="_blank"
                  rel="noreferrer"
                  title="Hit counter"
                  data-name="2ab144abc57e17af11df682059a16e88|5|external|2000|#0099cc|#f5f5f5|large|s-hit"
                >

                </a>
                <script>
                  document.write("
                  <script
                    type="text/javascript"
                    src='https://visitorshitcounter.com/js/hitCounter.js?v="+Date.now()+"'
                  ></script>
                  ");
                </script>
                <div className="col-xs-12 mt20" id="bg">
                  <div

                    style={{
                      margin: "0 auto",
                      width: "310px",
                      height: "80px",
                      background: "none",
                      textAlign: "left",
                      borderRadius: "5px",
                      border: "1px solid white",
                      padding: "3px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <span
                      style={{
                        padding: "4px",
                        display: "inline-block",
                        borderRight: "1px solid #ffffff",
                      }}
                    >
                      <a
                        href="www.dragrawaleyecaremandla.in"
                        rel="noreferrer"
                        target="_blank"
                        title="Visitor Counter"
                        style={{
                          color: "#ffffff",
                          textDecoration: "none",
                          fontSize: "25px",
                          fontWeight: "bold",
                          textTransform: "uppercase",
                          whiteSpace: "nowrap",
                          marginRight: "1px",
                        }}
                      >

                        Total visitors
                      </a>
                    </span>
                    <span
                      className="text"
                      id="dupli_hit_counter"
                      style={{

                        display: "inline-block",
                        color: "#ffffff",
                        width: "100%",
                        fontSize: "30px",
                        textAlign: "center",
                        fontWeight: "bold",
                        marginLeft: "2px"
                      }}
                    >
                    </span>
                    <input
                      type="hidden"
                      id="site_val"
                      className="visitor-counter"
                      value="https://visitorshitcounter.com/counterDisplay?code=2ab144abc57e17af11df682059a16e88&style=0017&pad=5&type=page&initCount=2000"
                    />
                  </div>
                </div>
              </div>
              <script src="https://visitorshitcounter.com/js/badgess.js?v=1738756182"></script>
            </div> */}

          </div>
          <div className="footer-col" id="footermap">
            <h3>LOCATION MAP</h3>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14661.646206897667!2d77.4463915!3d23.2644911!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x397c694562b9bb21%3A0xfb0f052048cabf4f!2sRoot%20N%20Tooth%20Skin%20Hair%20and%20Dental%20Clinic!5e0!3m2!1sen!2sin!4v1773821002888!5m2!1sen!2sin"
              width="400"
              height="300"
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
              title="clinic-location-map"
            />
          </div>
        </div>
      </div>

      <div className="policy" id="footer-policy">
        <div className="policy-row">
          <div className="policy-col">
            <p>Copyright © Root And Tooth Dental Clinic</p>
          </div>
          <div className="policy-col">
            <p>
              Design with <i className="fa-sharp fa-solid fa-heart"></i> by{" "}
              <a href="https://maitretech.com/" target="_blank" rel="noreferrer">
                maitretech.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
